<template>
  <div data-testid="treeItem" role="treeitem" class="flex" :class="level === 1 ? 'bg-gray-lighter' : 'bg-gray-light'">
    <div class="p-5 text-gray-darkest leading-tight">
      <UniversalLink
        :id="`panel${level + 1}-${data._uid}`"
        :link="data.link.url"
        :data-level="level"
        class="block mb-5 font-bold text-black whitespace-nowrap focus:outline focus:outline-1 focus:outline-action"
        @keydown.shift.tab.prevent="focusPanel(`panel${level}-${data._uid}`)"
        >{{ data.text }}</UniversalLink
      >

      <div class="flex">
        <template v-for="linkGroup in linkGroups" :key="linkGroup._uid">
          <div class="ml-5 pl-5 border-l-2 border-gray-light first:ml-0 first:pl-0 first:border-0">
            <template v-for="item in linkGroup">
              <template v-if="$storyblok.isVisible(item)">
                <div :key="item._uid" v-bind="$storyblok.bindStoryblokBridgeData(item)" class="w-48 cursor-pointer">
                  <UniversalLink
                    :id="`panel${level + 1}-${item._uid}`"
                    :link="item.link.url"
                    class="flex justify-between items-center mb-3 text-sm text-black focus:outline focus:outline-1 focus:outline-action"
                    :data-level="level"
                    @touchstart.passive="showMenu(item._uid)"
                    @focus="showMenu(`panel3-${item._uid}`)"
                    @mouseenter="showMenu(item._uid)"
                    @mouseleave="clearTimer"
                    >{{ item.text }}
                    <div
                      v-if="item?.items"
                      role="button"
                      aria-label="Expand menu"
                      tabindex="0"
                      class="text-gray items-center justify-center w-3 h-3 ml-2 focus:outline focus:outline-1 focus:outline-action"
                      @focus="showMenu(item._uid)"
                      @keyup.enter.prevent="focusPanel(`panel${level + 2}-${item._uid}`)"
                    >
                      <ArrowIcon class="w-3 h-3 transform -rotate-90 fill-current" />
                    </div>
                  </UniversalLink>
                </div>
              </template>
            </template>
          </div>
        </template>
      </div>
    </div>

    <!-- Recursively build further child panels -->
    <template v-if="data.items">
      <template v-for="item in data.items">
        <template v-if="item.items">
          <template v-if="$storyblok.isVisible(item)">
            <TreeItem v-show="activeMenuId === item._uid" :key="item._uid" :data="item" :level="level + 1"></TreeItem>
          </template>
        </template>
      </template>
    </template>
  </div>
</template>

<script setup lang="ts">
import ArrowIcon from '@/assets/arrow.svg?component'
const { $storyblok } = useNuxtApp()
// interface TreeItem extends NavbarItem {
//   items: TreeItem[]
// }
const props = withDefaults(
  defineProps<{
    data: TreeMenuItem
    level?: number
    isActive?: boolean
  }>(),
  {
    level: 1,
    isActive: false,
  }
)

const activeMenuId = ref()
watch(
  () => props.isActive,
  (newVal) => {
    if (!newVal) activeMenuId.value = null
  }
)

const linkGroups = computed(() => {
  if (!props.data.items) return []

  const groups = []
  const chunkSize = 14
  for (let i = 0; i < props.data.items.length; i += chunkSize) {
    const chunk = props.data.items.slice(i, i + chunkSize)
    groups.push(chunk)
  }

  return groups
})

let navHoverTimer: any
function clearTimer() {
  // If they mouseleave before the showMenu timer is done, clear it so we don't show it
  clearTimeout(navHoverTimer)
}

function showMenu(menuIndex: string) {
  clearTimeout(navHoverTimer)

  navHoverTimer = setTimeout(() => {
    activeMenuId.value = menuIndex
  }, 175)
}

function focusPanel(id: string) {
  const panel = document.getElementById(id)
  if (panel) panel.focus()
}
</script>
